import { AudienceSelectorList } from "./AudienceSelectorList";
import {
	getAudienceSelection,
	eventMisfired,
	financialProfessionalGUID
} from "./utility/audienceSortApiHandlers";
import {
	AudienceSelectorGlobalSplashProps,
	SectionAudienceType
} from "./utility/audienceSortPropTypes";
import { audienceSortStepNames } from "./utility/audienceSortStepNames";
import { sanitizeHtml } from "utils/sanitizeHtml";

const AudienceSelectorGlobalSplash: React.FC<AudienceSelectorGlobalSplashProps> = ({
	initialData,
	introduction,
	setStep,
	setIsModalOpen,
	setCameFromInitialStep,
	audienceTypesData,
	setAudienceSelectionData,
	currentPage
}) => {
	const handleAudienceSelection = async (event, item) => {
		await getAudienceSelection(
			event,
			item,
			"redirect",
			audienceTypesData,
			setAudienceSelectionData,
			currentPage
		);

		if (item.audienceTypeId === financialProfessionalGUID) {
			setStep(audienceSortStepNames.financialProfessionalAffirmation);
			setIsModalOpen(true);
			setCameFromInitialStep(true);
		}
	};

	const sectionAudienceTypeEventHandler = async (
		event: React.MouseEvent | React.KeyboardEvent,
		item: SectionAudienceType
	): Promise<void> => {
		if (eventMisfired(event)) return;
		handleAudienceSelection(event, item);
	};

	return (
		<>
			<div className="audience-selector-global-splash-container">
				{introduction && (
					<span
						className="audience-selector-global-splash-intro t-body-sm"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(introduction) }}
					/>
				)}
				<AudienceSelectorList
					currentPage={currentPage}
					audienceTypes={initialData.sectionAudienceType}
					eventHandler={sectionAudienceTypeEventHandler}
				/>
			</div>
		</>
	);
};

export default AudienceSelectorGlobalSplash;
